export default __webpack_public_path__ + "static/media/visa.51a4248f.svg";